 
 $(function(){
  console.log('fee')

/*  setTimeout(function(){
    let kiwi = $('.ks-chart-container').detach()
    $('variant-swatch-king').append(kiwi)
  },1500)


  setTimeout(function(){
        $('.ks-chart-container').show()
  },1600)
*/
    setTimeout(function(){
   pro_swatches()
    },2000)
    

    $(document).on('click','.swatch-view-item',function(){
      console.log('dwdwd')
    pro_swatches()
  })
  })
     function pro_swatches(){
    let final ='';
    let comb= '';
    $('.swatch-selector.swatch-selected').each(function(){
      let checked_val= $(this).attr('data-value');
      comb += checked_val + ' / '
    })
    console.log(comb)
    var finall =comb.slice(0 ,comb.length-2).trim();
    console.log('--final combination',finall);

    let flag=false;
    $(".u_master_select option").each(function(){
      var word =$(this).attr('data-title').trim();
      if(word == finall){
        console.log('---',word);
        flag =true;
      }
    })
      if(flag==true)
    {
      //master select
      $(".u_master_select option").each(function(){
        if($(this).attr('data-title').trim() == finall){
          $('.u_master_select').val($(this).val()).trigger('change');
         let var_title = $(this).attr('data-title').trim()
          // variant change price
          var variant_price = $(this).attr('price-data');
          let compare_variant_price = $(this).attr('compare-price-data');
          console.log('variant price',variant_price,'compare at price',compare_variant_price);
          let minus = compare_variant_price - variant_price;
          let off = Math.round((minus / compare_variant_price)*100);          
          console.log(off)
 let off_f = Math.round(off / 5);
          let off_ff = off_f*5;
          console.log(off_ff)
          $('.product__price-savings').text(`${off_ff}% Rabatt`)    
        }
      })
     }
     }